:host {
  display: block;
}

.work-hours {
  position: relative;
}

.work-hours-trigger {
  border: 0;
  margin-left: 10px;
  width: 16px;
  height: 16px;
  background-color: var(--av-color-accent);
  color: var(--av-color-accent-contrast);
  border-radius: 8px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-style: italic;
  font-family: serif;
  cursor: pointer;
}

// .work-hours-dark {
//   .work-hours-trigger {
//     background-color: white;
//     color: var(--av-font-color-dark);
//   }
// }

.work-hours-card {
  div.av-card {
    &.av-card-floating {
      bottom: auto;
      top: 25px;
    }
    .av-card-body {
      max-height: 300px;
      overflow: auto;
      padding: 8px;
    }
  }
}

.work-hours-title {
  font-size: 1.1em;
  display: block;
}

.work-hours-title-air {
  margin-top: 10px;
}

.work-hours-item {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--av-card-separator-color);
  padding: 10px 0;
  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
}

.work-hours-item-entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.work-hours-item-reason {
  font-size: 0.9em;
  font-style: italic;
}

.work-hours-item-day,
.work-hours-item-time {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 2;
}

.work-hours-item-time {
  justify-content: flex-end;
  flex: 1;
}

.pill {
  padding: 4px 8px;
  background-color: var(--av-color-gray);
  color: var(--av-font-color-dark);
  margin: 2px;
  font-size: 0.9em;
  border-radius: var(--av-border-radius-button);
  display: inline-block;
}
